import { render, staticRenderFns } from "./card.vue?vue&type=template&id=291b537f&scoped=true&"
var script = {}
import style0 from "./card.vue?vue&type=style&index=0&id=291b537f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b537f",
  null
  
)

export default component.exports